"use client";

import React, {useEffect, useState} from "react";
import {usePathname} from "next/navigation";
import {NavigationLink} from "~/components/navigation/Link";
import {NavigationItem} from "@/utils/content/navigation";
import {Locale} from "~/i18n-config";
import clsx from "clsx";

export function FooterNavigation(
    { lang, navigation } :  { lang: Locale, navigation: NavigationItem[] }
) {
    return (
        <nav className="footer md:flex md:flex-row md:gap-8">
            <FooterNavigationItems lang={lang} navigation={navigation} level={0} visible={true} />
        </nav>
    );
}

export function FooterNavigationItems(
    { lang, navigation, level, visible } :  { lang: Locale, navigation: NavigationItem[], level: number, visible: boolean }
) {
    return (
        <ul className={clsx(level == 0 || visible ? "md:block" : "md:hidden", "nav level-" + level)}>
            {navigation.map((item: NavigationItem) => (
                <FooterNavigationItem key={"fn-" + item.id} lang={lang} item={item} level={0} />
            ))}
        </ul>
    );
}

export function FooterNavigationItem(
    { lang, item, level } :  { lang: Locale, item: NavigationItem, level: number }
) {

    const pathname = usePathname();

    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        setShowMenu(false);
    }, [pathname]);

    return (
        <li
            onMouseEnter={(e) => setShowMenu(true) }
            onMouseLeave={(e) => setShowMenu(false) }>
            <NavigationLink
                lang={lang}
                item={item}
                className="text-lg font-normal" />
            {item.children && item.children.length > 0 && (
                <FooterNavigationItems lang={lang} navigation={item.children} level={level + 1} visible={showMenu} />
            )}
        </li>
    );

}